module.exports = __webpack_public_path__ + "static/tank-066c8f388281ac43c93abefd8d6d1849.jpeg";